// extracted by mini-css-extract-plugin
export var button = "delete-button-module--button--asp-Q";
export var container = "delete-button-module--container--+tgBD";
export var trash = "delete-button-module--trash--9FB0T";